"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Dashboard;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Dashboard(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "dashboard"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50,12.76A42.5,42.5,0,0,0,17.2,82.285,2.5,2.5,0,0,0,21.056,79.1a37.5,37.5,0,1,1,57.888,0A2.5,2.5,0,0,0,82.8,82.285,42.5,42.5,0,0,0,50,12.76Z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: 50,
    cy: "27.283",
    r: "4.624",
    transform: "translate(-3.725 8.361) rotate(-9.217)"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "27.803",
    cy: "40.231",
    r: "4.624"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "72.197",
    cy: "40.231",
    r: "4.624"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "75.896",
    cy: "64.277",
    r: "4.624"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "24.104",
    cy: "64.277",
    r: "4.624"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M64.079,48.568a2.5,2.5,0,0,0-3.38,1.037L52.354,65.331a2.459,2.459,0,0,0-.281,1.2,9.262,9.262,0,1,0,3.855,2.052,2.484,2.484,0,0,0,.842-.906l8.345-15.726A2.5,2.5,0,0,0,64.079,48.568ZM53.545,77.481a4.247,4.247,0,0,1-3.76,2.259,4.192,4.192,0,0,1-1.984-.5,4.25,4.25,0,0,1,2-8,4.25,4.25,0,0,1,3.744,6.242Z"
  })))));
}